/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureDevOpsBuildWorkItemsResponse {
    getFixupPrototypeFunction() { return AzureDevOpsBuildWorkItemsResponse.fixupPrototype; }

    static newInstance(model: Partial<AzureDevOpsBuildWorkItemsResponse>): AzureDevOpsBuildWorkItemsResponse {
        let obj = Object.assign(new AzureDevOpsBuildWorkItemsResponse(), model);
        AzureDevOpsBuildWorkItemsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureDevOpsBuildWorkItemsResponse>): AzureDevOpsBuildWorkItemsResponse {
        if (!model) return null;
        return AzureDevOpsBuildWorkItemsResponse.newInstance(<AzureDevOpsBuildWorkItemsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureDevOpsBuildWorkItemsResponse) {
        if (!obj) return;

        models.AzureDevOpsBuildWorkItemsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureDevOpsBuildWorkItemsResponse): boolean {
        Object.setPrototypeOf(obj, AzureDevOpsBuildWorkItemsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.workitems) {
            for (let val of this.workitems) {
                models.AzureDevOpsBuildWorkItem.fixupPrototype(val);
            }
        }
    }

    /**
     * List of workitems associated with build
     */
    workitems: Array<models.AzureDevOpsBuildWorkItem>;

}
